import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { CartProvider } from "@/context/CartContext";
import { AuthProvider } from "@/context/AuthContext";
import { SmoothScroll } from "@/components/site/SmoothScroll";
import { Header } from "@/components/site/Header";
import { Footer } from "@/components/site/Footer";
import { CartDrawer } from "@/components/site/CartDrawer";
import { AuthCallback } from "@/components/site/AuthCallback";
import Home from "@/pages/Home";
import ProductPage from "@/pages/ProductPage";
import OrderPage from "@/pages/OrderPage";
import Account from "@/pages/Account";
import Admin from "@/pages/Admin";
import Legal from "@/pages/Legal";

const AppRouter = () => {
  const location = useLocation();
  if (location.hash?.includes("session_id=")) return <AuthCallback />;
  return (
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/produit/:id" element={<ProductPage />} />
      <Route path="/commande/:id" element={<OrderPage />} />
      <Route path="/compte" element={<Account />} />
      <Route path="/admin" element={<Admin />} />
      <Route path="/legal/:slug" element={<Legal />} />
    </Routes>
  );
};

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <CartProvider>
          <SmoothScroll />
          <Header />
          <main><AppRouter /></main>
          <Footer />
          <CartDrawer />
          <Toaster position="bottom-center" />
        </CartProvider>
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
